ACDiscountApp.CartPage.Show_CalculateTier = function () {
    let TierProducts = [];
    var postDataDiscountArrayObject = [];
    var discountMsg  = "TIERED_DISCOUNT";
    let discountedAmount = '';
    let runAttributeCode = true;
    const chunkSize = 106;
  // Utility function to create a discount object, used in all three discount types.
  function createDiscountObject(msg, variantId, value) {
    return {
      message: msg,
      targets: [{ productVariant: { id: variantId } }],
      value: value,
    };
  }

  // Creates a percentage discount object as per Shopify requirements.
  function createPercentageDiscountObject(msg, percentage, variantId) {
    return createDiscountObject(msg, variantId, {
      percentage: { value: percentage },
    });
  }

  // Creates a fixed amount discount object and calculates the total discount amount.
  function createAmountOffDiscountObject(
    msg,
    variantId,
    currencyRate,
    amount,
    qtys
  ) {
    const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
    return createDiscountObject(msg, variantId, {
      fixedAmount: { amount: totalDiscountedAmount },
    });
  }

  // Creates a discounted price object and calculates the discount based on the original price.
  function createDiscountedPriceDiscountObject(
    msg,
    variantId,
    currencyRate,
    amount,
    qtys,
    price
  ) {
    let discountAmount = (amount * currencyRate).toFixed(2);
    price = Number(price);
    discountAmount = Number(discountAmount);
    if (price > discountAmount) {
      const discountValue = (price - discountAmount).toFixed(2);
      const totalDiscountedAmount = (discountValue * qtys).toFixed(2);

      return createDiscountObject(msg, variantId, {
        fixedAmount: { amount: totalDiscountedAmount },
      });
    }

    // Return null or a default value if no discount applies (optional based on your use case)
    return null;
  }

  async function setDateTimeInCart() {
    
    try {


const separation = [30,30,25,21];

let attributes = {};
let chunks = [];

if (runAttributeCode && postDataDiscountArrayObject.length > 0) {

    let startIndex = 0;

    for (let i = 0; i <= separation.length; i++) {

        const currentChunkSize = separation[i];

        chunks.push(
            postDataDiscountArrayObject.slice(
                startIndex,
                startIndex + currentChunkSize
            )
        );

        startIndex += currentChunkSize;
    }
}

for (let i = 0; i < separation.length; i++) {

    let key = i === 0
        ? "Discountly_dateTime"
        : `Discountly_dateTime_${i}`;

    attributes[key] = chunks[i] && chunks[i].length
        ? JSON.stringify(chunks[i])
        : "";
}

    // attributes["Discountly_BogoDiscount"] =`${globalFields.Storetime()},${Shopify.shop}`;
        
    //   let manageDiscountLimit = postDataDiscountArrayObject.slice(0,80)

     let cartAttributes =  attributes;
  //    let cartAttributes = globalFieldsCartPage_AC.cartObj.items.length < 0 
  // ?  {Discountly_dateTime: `${globalFields.Storetime()},${Shopify.shop}`}
  // : attributes;

   /* let cartAttributes = JSON.stringify(postDataDiscountArrayObject);*/
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes:cartAttributes
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      if(globalFieldsCartPage_AC.cartObj?.original_total_price != data?.original_total_price){
        globalFieldsCartPage_AC.cartObj = data;
        TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      }
       
       jQuery(".loading-overlay").addClass("hidden");
   
    } catch (error) {
      // console.error('Failed to update cart:', error);
    }
  }


    // Item and line Item Price Selector;
     var cartPageItemPrice = '#cartform .cart-item .cart-item__price';
     var cartPageLineItemPrice = '#cartform .cart-item .cart-item__total';
  
     var drawerItemPrice = '.drawer__cart-items-wrapper .cart-item__details';
     var drawerLineItemPrice = '.drawer__cart-items-wrapper .cart-item__details';
    
      // Cart Total Selector Drawer and cart page;
     var cartPageCartTotalPrice = '#cartform .checkout-subtotal-container__dynamic .subtotal';
  
     var drawerCartTotalPrice = '.cart-summary-overlay  .cart-summary-overlay__subtotal .cart-summary-overlay__subtotal-amount';
  
     // Saving Message 
     var savingMessageCartPage = '#cartform .checkout-subtotal-container .subtotal';
      // CheckOut Button;
     var checkoutButtonCartPage = '.checkout-buttons button[name="checkout"]';
     
     var checkoutButtonDrawerPage = '#cart-notification button[name="checkout"]';
  
 
  function getVisiblePriceWrapperSelectorAt(index) {
    const parent = document.querySelector('.cart__items');
    if (!parent) return null;

    const selector1 = '.cart-item__totals.right.small-hide .cart-item__price-wrapper';
    const selector2 = '.cart-item__totals.right.medium-hide.large-up-hide .cart-item__price-wrapper';

    const el1 = parent.querySelectorAll(selector1)[index];
    const el2 = parent.querySelectorAll(selector2)[index];

    const isVisible = (el) => {
      return el && window.getComputedStyle(el).display !== 'none' && el.offsetParent !== null;
    };

    if (isVisible(el1)) return selector1;
    if (isVisible(el2)) return selector2;

    return null;
  }

function parseDiscountString(tags, main_str, buyAmount, getAmount) {
  try {
    // Match all X or x characters (case-insensitive)
    const matches = main_str.match(/[xX]/g);
    // If fewer than 2, no dynamic replacement needed
    if (!matches || matches.length < 2) {
      return main_str;
    }
    // Replace first X/x with buyAmount, second with getAmount
    let xCount = 0;
    const replacedStr = main_str.replace(/[xX]/g, () => {
      xCount++;
      return xCount === 1 ? buyAmount : getAmount;
    });
    // Only prepend tags if not already in main_str
    const prefix = main_str.startsWith(tags) ? '' : `${tags} `;
    return `${prefix}${replacedStr}`;
  } catch (error) {
    return main_str;
  }
}


  

   var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index,discountMsg,discountedAmount) {
      // if(globalFieldsCartPage_AC.cartObj.items.length < 0 )return
      if (isUpdate) {

       
      
         let findSelecter = ''
        if(jQuery(cartPageItemPrice).eq(index).find('.cart-item__discounted-prices').length == 1){findSelecter = '.cart-item__discounted-prices'}
        else{findSelecter = '.product-option:first'}
      var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
      var condition1 = updatedItemPrice == originalItemPrice;
      updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);

      if (isNotInRange || condition1) {
      jQuery(cartPageItemPrice).eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(cartPageLineItemPrice).eq(index).html('<div ><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
      jQuery(`.cart-summary-overlay div[data-item-key="${item.key}"] .cart-summary-overlay__column-price`).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(`.cart-summary-overlay div[data-item-key="${item.key}"] .cart-summary-overlay__line-price`).html('<div ><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
     
      }
      else {

        discountedAmount = globalFields.ConvertToFixedDecimalString(discountedAmount)
        
        let discountTitel = `<ul class="cart-discount-list ac-discount"><li class="cart-discount"><div class="cart-discount__label"><span class="cart-discount__icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg></span><span class="cart-discount__title">${discountMsg}</span></div><div class="cart-discount__amount theme-money">${ globalFields.formatMoney(discountedAmount, globalFields.amount)}</div></li></ul>`
       let discountTitleOnPrice = $(window).width() < 1024 ? discountTitel : '';
        originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
       jQuery(cartPageItemPrice).eq(index).html('<div class="cart-item__original-price"><div class="struck-out-price"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span>'+discountTitleOnPrice+'</div>');
      jQuery(cartPageLineItemPrice).eq(index).html('<span><span class="cart-item__original-price"><s class="struck-out-price"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></span></br><span><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span></span>'+ discountTitel);
      jQuery(`.cart-summary-overlay div[data-item-key="${item.key}"] .cart-summary-overlay__column-price`).html('<div class="cart-item__original-price"><div class="struck-out-price"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(`.cart-summary-overlay div[data-item-key="${item.key}"] .cart-summary-overlay__line-price`).html('<span><span class="cart-item__original-price ac-"><s class="struck-out-price"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></span></br><span><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span></span>');
        jQuery(`.cart-summary-overlay div[data-item-key="${item.key}"] .cart-discount-list`).remove()
        jQuery(`.cart-summary-overlay div[data-item-key="${item.key}"] .cart-summary-overlay__column-total`).after(discountTitel)
      }
      }
}
   
   


  var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
  //  if(globalFieldsCartPage_AC.cartObj.items.length < 0)return
    if (isUpdate) {
        updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
        if (originalTotalPrice != updatedTotalPrice) {
        //<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s>
          jQuery(drawerCartTotalPrice).html(' <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        jQuery(cartPageCartTotalPrice).html(`<span style="font-weight: bold;width: 60%; font-size: 26px;">Total</span><div style="text-align: right;"><div style="text-decoration: line-through; font-size: 20px;     font-weight: 500;  font-style: italic; color: black;">${ globalFields.formatMoney(originalTotalPrice, globalFields.amount)}
</div><div style="font-weight: bold; font-size: 28px;  font-weight: 600; color: black; word-spacing: 1px;letter-spacing: 2px;">${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)}
</div>
  </div>`);
       }
        else {
       jQuery(drawerCartTotalPrice).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
       jQuery(cartPageCartTotalPrice).html('<span style="font-weight: bold;width: 60%; font-size: 26px;">Total</span><div style="text-align: right;"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span></div>');
      }
    }
}


         var UpdateSavingMessage = function (isUpdate) {
            //  if(globalFieldsCartPage_AC.cartObj.items.length < 0 )return
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
            jQuery('#saved-banner-div').length == 0 ? jQuery(savingMessageCartPage).after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
            jQuery('#saved-banner-div').length == 0 ? jQuery(savingMessageCartPage).after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }

  
/*var CheckoutClickCart = function () {
    async  function CallGetCodecart(e) { // This is only for the cart page
      e.preventDefault()
        TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
       await setDateTimeInCart();
        window.location.href = '/checkout';
    }
    jQuery(checkoutButtonCartPage).once('click', CallGetCodecart);
};*/

      var CheckoutClickCart = function () {
        jQuery(checkoutButtonCartPage).click(async function (e) {
          e.preventDefault()
        TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
         await setDateTimeInCart();
        window.location.href = '/checkout';
        });
    }

   var CheckoutClickAjax = function () {
 async function CallGetCodeAjax() {// this is  only for ajax and drawer 
     TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
      await setDateTimeInCart();
     window.location.href = '/checkout'
 }
 jQuery('.drawer-bottom button[name="checkout"]').once('click', CallGetCodeAjax);
}

  jQuery.fn.once = function(a, b) {
   return this.each(function() {
    jQuery(this).off(a).on(a,b);
   });
 };
  

    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
            jQuery.ajax({
                type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCodeMultiCurrencycombined",
                  data: {TierProductsarray:JSON.stringify(TierProducts),priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString(),cartobject:JSON.stringify(globalFieldsCartPage_AC.cartObj) },
                success: function (result) {
                    var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                      	window.location.href = '/checkout?discount=' + DiscountCode;
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                        window.location.href = '/checkout?discount=' + DiscountCode;
                    }
                },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout?discount=' + 'NODISCOUNT'; }
            });
        }
        else if (isUpper) {
          window.location.href = '/checkout?discount=' + '';
        }
      else{
       window.location.href = '/checkout?discount=' + '';
      }
    }

    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

  	var hide_buttons = null;
  	var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }


    var variantIdsToSend = [],
    minimumDiscountSubtotal = 0,
    priceDiff = 0;
    var TieredPricingCart = function (cartObject, isUpdate) {
      if ($(window).width() > 1024) { // desktop breakpoint (adjust if needed)
        $('#cartform .cart-item .cart-item__price .cart-discount-list').hide();
      }
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
      TierProducts = [];postDataDiscountArrayObject = [];
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
          // Exlude customer 
           // var customerExludeoption = true;
           // if(itemTiers != undefined) {
           //   customerExludeoption =  globalFields.customerExludeTags(itemTiers.excludeCustomerTags)
           //  }
          if (itemTiers != undefined && itemTiers.status  &&  globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
        
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else {
              
                UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, true, k,discountMsg,discountedAmount);
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
          
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
        }
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
        setDateTimeInCart();
          setTimeout(function(){
            makeEnableDisablebtn(false)
          }, 800);
      
      
      	if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    }
setTimeout(function(){
      clearInterval(hide_buttons);
    }, 10000);
    
    var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
        if (tierObj[0]?.tiers == "[]" || tierObj[0]?.tiers.length == 0) {
            return undefined;
        }
        else {
            return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
        }
    }

    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
      let isFound = TierProducts.some(element => {if (element.VarientID === item.variant_id) { return true;}return false;});

        for (i = 0; i < itemTiers.tier_min.length; i++) {
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            let tempTierProductsobj = {};
           let postDataDiscountObject = {};
            var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

                 /*start if condtion*/ 
        if(itemTiers.mixMatch){
          if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].mixmacthentityId == itemTiers.mixmacthentityId && n.tiers[0].mixMatch); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                if (itemTiers.entity_type === 'products') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'products' && n.tiers[0].mixmacthentityId == itemTiers.mixmacthentityId && n.tiers[0].mixMatch); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                   var tempItemArray = [];
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'variants' && n.tiers[0].mixmacthentityId == itemTiers.mixmacthentityId && n.tiers[0].mixMatch); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;

               }
                
              }
/*End Condtion*/
              else{
                if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections notuse') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }
              }
            

            if (condition1 && condition2) {
              var Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
              //var currencyRate = Shopify.currency.rate;
               var currencyRate = '1';
              var qtys = item.quantity;
              var price = Number(item.original_price / 100).toFixed(2);
               discountMsg = itemTiers?.discountCouponTitle || "TIERED_DISCOUNT"
               discountMsg = parseDiscountString("",discountMsg,minTier,tierPrice);
               discountedAmount = ''
                isNotInRange = false;
                if (itemTiers.discount_type == 'percentage') {
                  
                 //   var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                    var originalPriceCut = getDiscountAmount(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100),parseFloat(tierPrice));
                     updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
                   
                  if(!isFound){
                         let resposne = createAmountOffDiscountObject(discountMsg,Vid,currencyRate,originalPriceCut, qtys);
                         postDataDiscountObject = resposne;
                      tempTierProductsobj['Discountvalue'] = postDataDiscountObject.value.fixedAmount.amount;
                      tempTierProductsobj['DiscountType'] = 'fixed';
                      tempTierProductsobj['VarientID'] = item.variant_id;
                     // let resposne = createPercentageDiscountObject(discountMsg,tierPrice,Vid);
                      //postDataDiscountObject = resposne;
                    }  
                }
                else if (itemTiers.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice* currencyRate));
                   if(!isFound){
                      let resposne = createAmountOffDiscountObject(discountMsg,Vid,currencyRate,tierPrice, qtys);
            postDataDiscountObject = resposne;
            tempTierProductsobj["Discountvalue"] = postDataDiscountObject.value.fixedAmount.amount;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
                    }
                 }
                else if (itemTiers.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice* currencyRate));
                    if(!isFound){
            tempTierProductsobj["Discountvalue"] = tierPrice;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
            let resposne = createDiscountedPriceDiscountObject(discountMsg, Vid,currencyRate,tierPrice,qtys,price);
            postDataDiscountObject = resposne;
                    } 
                }
               
                if (postDataDiscountArrayObject.length > chunkSize) {
                  isFound = true
                  isNotInRange = true
                }

                if (updatedItemPrice < 0) { updatedItemPrice = 0; }
                if(updatedItemPrice <= item.original_price/100 && chunkSize > postDataDiscountArrayObject.length){
                    updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                    discountedAmount = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100) - updatedLinePrice;
                    discountedAmount = globalFields.ConvertToFixedDecimalNumber(discountedAmount);
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                    UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index,discountMsg,discountedAmount);
             }else{isNotInRange = true}
            if (!isFound) {
              if (postDataDiscountObject != null) {
                postDataDiscountArrayObject.push(postDataDiscountObject);
              TierProducts.push(tempTierProductsobj);
              }
            }
            }
        }
        if (isNotInRange) {
          UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index,discountMsg,discountedAmount);
        }
        return [updatedTotalPrice, isNotInRange];
    }

    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }
    
    function getDiscountAmount(price, discountPercentage) {
  if (typeof price !== 'number' || typeof discountPercentage !== 'number') return 0;
  return +(price * (discountPercentage / 100)).toFixed(2);
}

    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                 makeEnableDisablebtn(true)
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                CheckoutClickAjax();
            },
            error: function (e) { 
              makeEnableDisablebtn(false)
              console.log(e.statusText); }
        });
    }
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });
  
      (function () {
    window.onpageshow = function(event) {
    if (event.persisted) {
    window.location.reload();
    }
    };
    })();
  var checkAddToCartResponse =async function(splittedUrl,responseText){
   
          if (splittedUrl[0] == "/cart/add.js") {
           setTimeout(async function () {
    
      try {
        const r = await fetch('/cart.js');
        const data = await r.json();
        
    if(hasNewCartItem(data) ){
          makeEnableDisablebtn(true)
          globalFieldsCartPage_AC.cartObj = data;
          setTimeout(function () {
            FetchCartTiers();
          }, 800);
        }
      } catch (err) {
        console.error("Error fetching cart:", err);
        return []
      }
          }, 800);
    }
  }
  

var ProcessCartResponse = async function (splittedUrl, responseText) {
      if ($(window).width() > 1024) { // desktop breakpoint (adjust if needed)
        $('#cartform .cart-item .cart-item__price .cart-discount-list').hide();
      }
  if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
    splittedUrl = splittedUrl.split("?");
     if (splittedUrl[0] == "/cart/add.js") {
          checkAddToCartResponse(splittedUrl,responseText)
     }


    if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js" ) {


    if(responseText && hasNewCartItem(JSON.parse(responseText)) ){
          makeEnableDisablebtn(true)
          globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
          setTimeout(function () {
            FetchCartTiers();
          }, 800);
        }
    }
  }
};



 try {
    var nativeFetch = window.fetch;
    window.fetch = function (...args) {
        try {
          if ($(window).width() > 1024) { // desktop breakpoint (adjust if needed)
            $('#cartform .cart-item .cart-item__price .cart-discount-list').hide();
          }
          let updateJsCall = false;
            const body = args[0].includes("/cart/update") ? JSON.parse(args[1]?.body || '{}') : '{}';
               updateJsCall= false
            if (body.attributes) {
              updateJsCall = false;
            } else {
              updateJsCall = true;
            }

            if (typeof args[0] === 'string' && (args[0].includes("/cart/change") || args[0].includes("/cart/add")) || (args[0].includes("/cart/update")  &&updateJsCall)) {
          makeEnableDisablebtn(true)
          setTimeout(function () {
            fetch('/cart.js')
              .then(r => r.json().then(data => ({ status: r.status, body: data })))
              .then(obj => {
              if(hasNewCartItem(obj.body) ){
              ProcessCartResponse("/cart.js", JSON.stringify(obj.body))
              }

            });
          }, 1200);
            }
        } catch (err) {
            console.error("Error in intercepting fetch:", err);
        }
        return nativeFetch.apply(window, args);
    }
} catch (e) {
    console.error("Error in overriding fetch:", e);
}
  $(document).ready(function () {
    $(document).on("keyup", '.quantity.cart-quantity  input[type="number"]', function () {

      makeEnableDisablebtn(true)
      setTimeout(() => {
        $(this).blur(); // Triggers the blur event
      }, 800);
    });

    $(document).on("blur", '.quantity.cart-quantity  input[type="number"]', function () {
     // console.log('blur')
      setTimeout(() => {
        //makeEnableDisablebtn(false)
         TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      }, 2000);


    });
  });
  
  
        function hasNewCartItem(newCart) {
      const oldCart = globalFieldsCartPage_AC.cartObj;

      // Quick length check
      if (oldCart.items.length !== newCart.items.length) {
        // Get existing storage or empty object
        if( newCart.items.length){
        let storedCostPrice = JSON.parse(localStorage.getItem('variantCostPrice')) || {};
        const cartVariantIds = new Set(newCart.items.map(item => item.variant_id));
        Object.keys(storedCostPrice).forEach(variantId => {
          if (!cartVariantIds.has(Number(variantId))) {
            delete storedCostPrice[variantId];
          }
        });
        localStorage.setItem('variantCostPrice', JSON.stringify(storedCostPrice));
      }
        return true;
      }

      // Collect old IDs in a Set for O(1) lookups
      const oldIds = new Set(oldCart.items.map(item => item.id));

      // Check if newCart has any ID not in oldCart
      const hasNew = newCart.items.some(item => !oldIds.has(item.id));

      if (hasNew) {
        return true;
      }

      // No new items → update cart + run side-effects
       setTimeout(() => {
   
      globalFieldsCartPage_AC.cartObj = newCart;
      makeEnableDisablebtn(true);
      TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      CheckoutClickCart();
      CheckoutClickAjax();
      }, 1800);
      return false;
    }

  jQuery(document).ready(function () {
    jQuery('.quantity__button').on('click', function (event) {
      event.preventDefault(); // Prevent default behavior (if any)
      makeEnableDisablebtn(true)
    });
  });
 jQuery('.quantity__button').on('click', function (event) {
    event.preventDefault(); // Prevent default behavior (if any)
    makeEnableDisablebtn(true)
  });
  
  
  function makeEnableDisablebtn(isEnable) {

    if(globalFieldsCartPage_AC.cartObj && globalFieldsCartPage_AC.cartObj.items.length > 100){
      isEnable = false
      return
    }
    if(isEnable){
      // jQuery('.drawer-bottom button[name="checkout"]').prop('disabled', true);
      jQuery(checkoutButtonCartPage).prop('disabled', true);
      jQuery(checkoutButtonCartPage).text('\n                    \n                      Loading...\n                    \n                  '); 
      jQuery('#cart-notification button[name="checkout"]').prop('disabled', true);
      jQuery('#cart-notification button[name="checkout"]').text('\n                    \n                      Loading...\n                    \n                  ')
     

    }else{
      jQuery(checkoutButtonCartPage).text('\n                    \n                      Checkout\n                    \n                  ')
      jQuery('#cart-notification button[name="checkout"]').text('\n                    \n                      Checkout\n                    \n                  ')
    
      //  jQuery('.drawer-bottom button[name="checkout"]').text('\n                    \n                      Checkout\n                    \n                  ')
    //  jQuery('.drawer-bottom button[name="checkout"]').prop('disabled', false);
      jQuery(checkoutButtonCartPage).prop('disabled', false);
      jQuery('#cart-notification button[name="checkout"]').prop('disabled', false);
      
    }

  }

  
  
  
   

  makeEnableDisablebtn(true)
  
  
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();